/* Tabs 标签页列表 */

import router from "@router";

import store from "@store";

const layoutPath = "welcome";

const defaultActivePath = "/layout/" + layoutPath;

export default {
  namespaced: true,

  state: {
    // 缓存组件页面
    catch_components: [],
    // 当前激活路由
    activePath: defaultActivePath,
    // 菜单项
    tabList: [
      {
        path: defaultActivePath,
        title: "控制台",
        name: layoutPath,
        icon: "el-icon-monitor",
      },
    ],
  },

  mutations: {
    /**
     * 选中菜单，生成标签页列表
     * @param {*} state
     * @param {*} value
     */
    selectMenuInfo(state, value) {
      // 首页 即 welcome
      if (value.name === layoutPath) {
        value.path = defaultActivePath;
      }

      // 当前选中菜单
      let activePath = value.path;
      // 历史已选中菜单列表
      let activeTabList = state.tabList;

      // 添加时判断是否已有该标签
      let isActive = activeTabList.some((val) => {
        if (val.path === activePath) {
          return true;
        }
      });

      //
      if (!isActive) {
        activeTabList.push({
          path: value.path,
          name: value.name,
          title: value.title,
          icon: value.icon,
        });

        /**
         * 添加keepAlive缓存
         */
        store.commit("tabs/insertKeepAliveCache", value.path);
      }

      // 重新赋值
      state.activePath = activePath;

      state.tabList = activeTabList;
    },
    /**
     * 添加 keepalive 缓存
     * @param {*} state
     * @param {*} value
     */
    insertKeepAliveCache(state, value) {
      // 首页 不缓存
      if (value === layoutPath) {
        return false;
      }

      // 添加时判断，如果该组件已存在，则不添加
      if (state.catch_components.indexOf(value) === -1) {
        // 不存在，缓存页面
        state.catch_components.push(value);
      }
    },
    /**
     * 删除 keepalive 缓存
     * @param {*} state
     * @param {*} value
     */
    removeKeepAliveCache(state, value) {
      let cache = state.catch_components;

      cache.forEach((val, index) => {
        if (val === value) {
          cache.splice(index, 1);
        }
      });

      state.catch_components = cache;
    },
    /**
     * 关闭标签
     * @param {*} state
     * @param {*} value
     */
    closeTabInfo(state, value) {
      let tabInfo = value.tabInfo;

      let tabIndex = value.tabIndex;

      // 已选中路由
      let activePath = state.activePath;
      // 已选中菜单列表
      let activeTabList = state.tabList;

      // 删除 tabList 中的该元素
      activeTabList.forEach((val, index) => {
        if (val.path === tabInfo.path) {
          activeTabList.splice(index, 1);
        }
      });

      /**
       * 删除keepAlive缓存
       */
      store.commit("tabs/removeKeepAliveCache", tabInfo.path);

      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tabInfo.path !== activePath) {
        return false;
      }

      // 如果length为1，必然只剩下首页标签，此时关闭后，更新到首页
      if (activeTabList.length === 1) {
        // 同时存储菜单
        state.activePath = defaultActivePath;

        state.tabList = activeTabList;

        // tab页向左跳转
        router.push({
          path: activeTabList[tabIndex - 1].path,
        });
        // 不再向下执行
        return false;
      }

      // 关闭的标签是最右边的话，往左边跳转一个
      if (tabIndex === activeTabList.length) {
        // 同时更新路径
        // tab页向左跳转
        activePath = activeTabList[tabIndex - 1].path;
      } else {
        // 同时更新路径
        // tab页向右跳转
        activePath = activeTabList[tabIndex].path;
      }

      router.push({
        path: activePath,
      });

      // 同时存储菜单
      state.activePath = activePath;

      state.tabList = activeTabList;
    },

    /**
     * 点击标签选择菜单
     * @param {*} state
     * @param {*} val
     */
    changeMenuInfo(state, val) {
      state.activePath = val;
    },
  },
};
